import React, { useMemo } from 'react';

import { tertiary600, gray100 } from 'components/new_ui/Colors';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import { useContext } from 'components/Managers/Dashboard/Context';
import useProgramRating from 'components/Managers/Dashboard/Hooks/useProgramRating';

export default function ProgramFeedback() {
  const { state: { filters } } = useContext();
  const { data: programRating, loading } = useProgramRating(filters);

  const rate = useMemo(() => programRating * 20, [programRating]);

  return (
    <>
      <h5 className="mt-5 mb-4">Program Feedback</h5>

      {loading ? <LoadingPlaceholder className="mb-3" /> : (
        <>
          <div className="dashboard-rating progress bg-white">
            <div
              className="progress-bar w-100"
              role="progressbar"
              style={{ background: `linear-gradient(90deg, ${tertiary600} ${rate}%, ${gray100} 0%)` }}
              aria-label="Program Feedback"
              aria-valuenow={rate}
              aria-valuemin="0"
              aria-valuemax="100"
            />
          </div>

          <div className="mt-1 text-center">
            {programRating}
            <span className="text-muted">/5</span>
          </div>
        </>
      )}
    </>
  );
}
